import { ref } from 'vue';

import { IFRAME_KYC_URL_LOCALSTORAGE_KEY } from '@/store/authorization';
import http from '@/utils/http';

const kycForm = () => http.get('kyc/form');

export const kycStatus = () => http.get('kyc/status');

const iframeUrl = ref();

export const getKYCIframeUrl = async () => {
  try {
    iframeUrl.value = window.localStorage.getItem(IFRAME_KYC_URL_LOCALSTORAGE_KEY);
    iframeUrl.value ??= (await kycForm())?.data;
    window.localStorage.setItem(IFRAME_KYC_URL_LOCALSTORAGE_KEY, iframeUrl.value);
  } catch (error) {
    console.error(error);
  }
  return iframeUrl.value;
};
